export default (state = {}, action) => {
  switch (action.type) {
    case 'APPISSUE':
      return action.payload;
    default:
      return state;
  }
};
